// Types
import { InvestigationActionPayload } from 'app/modules/investigations/types/requests';
import {
  InvestigationsActionResponse,
  InvestigationsPayload,
} from 'app/modules/investigations/types';

// Utils
import { get, post } from 'app/shared/utils/fetchr';
import { consoleError } from 'app/shared/utils/console';
import { store } from 'app/store/configureStore';
import { selectDLEnabledForCaseDetail } from 'app/shared/featureFlags/selectors';

export const retrieveInvestigationsCase = <TResponse>(
  payload: InvestigationsPayload,
) => {
  const useNewEndpoint = selectDLEnabledForCaseDetail(store.getState());

  if (useNewEndpoint) {
    if (!payload?.object_ids?.[0]) {
      consoleError({
        error: 'No object_ids provided',
        info: { payload },
      });
      return Promise.reject(new Error('No object_ids provided'));
    }
    return get<TResponse>(`/v1/cases/cached/${payload?.object_ids?.[0]}`);
  }
  return post<TResponse>('/v1/investigations/retrieve/case', payload);
};

export const retrieveInvestigationAgentStats = (
  payload: InvestigationsPayload,
) => post('/v1/investigations/agent-stats', payload);

export const performInvestigationAction = (
  payload: InvestigationActionPayload,
) => post<InvestigationsActionResponse>('/v1/investigations/action', payload);
